import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CompanyBrandingProvider } from "./contexts/CompanyBrandingContext";
import Routes from "./Routes";
import FloatingWidgets from "./components/layout/FloatingWidgets";

function App() {
  return (
    <LanguageProvider>
      <CompanyBrandingProvider>
        <AuthProvider>
          <SidebarProvider>
            <Routes />
            <FloatingWidgets />
          </SidebarProvider>
        </AuthProvider>
      </CompanyBrandingProvider>
    </LanguageProvider>
  );
}

export default App;
